import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, styled } from "@mui/material";
import { useRouter } from "next/router";
import { default as React, useContext } from "react";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import MemoizedSearchInput from "./Banner/searchInput";
import { MemoizedTabHeader } from "../../layouts/tabHeader";

const CustomSearchHeader = styled(Box)(({ theme, isProductPage }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  width: "100vw",
  ".blank-box": {
    width: "100%",
    background: primary?.inactiveState,
    height: isProductPage ? "40px" : "80px",
  },
  ".search-bar-container": {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    top: isProductPage ? "-8px" : "-20px",
    width: "40%",
  },
  ".search-bar-container.sticky": {
    borderRadius: "100px",
    zIndex: 1,
    backgroundColor: primary?.white,
  },
  ".back_arrow": {
    display: "none",
  },

  ".banner-container": {
    width: "100vw",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    marginBottom: "20px",
  },
  ".banner1": {
    width: "84%",
    objectFit: "contain",
    // height: "13rem",
    minHeight: "8rem",
    justifySelf: "center",
  },
  ".banner2": {
    display: "none",
  },
  ".banner1img": {
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    ".search-bar-container": {
      width: "80%",
    },
    ".back_arrow": {
      display: "none",
    },
    ".banner-container": {
      width: "100%",
      height: "128px",
      justifyContent: "center",
    },
    ".banner1": {
      width: "98%",
      height: "128px",
      justifySelf: "center",
    },
    ".banner2": {
      display: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".search-bar-container": {
      gap: "1rem",
      padding: "0 18px",
      width: "100%",
      top: isProductPage ? "-16px" : "-24px",
    },
    ".search-bar-container.sticky": {
      zIndex: 1,
      backgroundColor: primary?.white,
    },
    ".back_arrow": {
      display: "block",

      background: primary?.lightPink,

      width: "55px",
      textAlign: "center",
      borderRadius: "100px",
      height: "55px",
      padding: "15px ",
      justifySelf: "flex-start",
      color: primary.main,
    },
    ".blank-box": {
      background: primary?.white,
      height: isProductPage ? "32px" : "48px",
    },

    "banner-container": {
      width: "100%",
    },

    ".banner2": {
      display: "block",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      ".banner1img": {
        width: "90%",
      },
    },
    ".banner1": {
      display: "none",
    },
  },
}));

const SearchHeader = ({isProductPage = false, showSearch = true}) => {
  const navigate = useRouter();

  const { searchValue, showHeader, hideHeader, showHeaderValue } = useContext(Context);

  return (
    // if product page reduce height of search bar
    <CustomSearchHeader isProductPage={isProductPage}>
      <Box className="blank-box"></Box>
      <Box
        className={`search-bar-container ${
          searchValue.length > 0 ? "sticky" : ""
        }`}
      >
        <HomeIcon
          onClick={() => navigate.push("/")}
          color="black"
          className="back_arrow"
          sx={{ display: { xs: "block", md: "none" } }}
        />

       <Box sx={{ display: { xs: "block", md: showSearch ? "block" : "none" } }}>
        <MemoizedSearchInput />
       </Box>
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <MemoizedTabHeader/>
          </Box>
        
        <MenuIcon
          onClick={() => {
            if (showHeaderValue) {
              hideHeader();
            } else {
              showHeader();
            }
          }}
          color="black"
          sx={{ 
            display: { xs: "block !important", md: "none !important" },
            cursor: "pointer",
            padding: "12px",
            borderRadius: "50%",
            fontSize: "28px",
            minWidth: "48px",
            minHeight: "48px",
            backgroundColor: "rgba(0,0,0,0.05)",
            "&:hover": {
              backgroundColor: primary?.lightPink,
            }
          }}
        />

      </Box>
    </CustomSearchHeader>
  );
};

const MemoizedSearchHeader = React.memo(SearchHeader);
export default MemoizedSearchHeader;
